const ImageLoader = {
  bind: (el, binding) => {
    const element = el;
    const url = binding.value.src;
    const img = new Image();

    if (binding.value.ratio) {
      element.style.paddingTop = Number.parseInt(binding.value.ratio, 10) * 100;
    }

    img.src = url;
    img.onload = () => {
      element.src = url;
      element.style.paddingTop = '0';
    };
    img.onerror = () => {
      element.src = binding.value.onerror;
      element.style.paddingTop = '0';
    };
  },
};

export default ImageLoader;
